__turbopack_context__.v({
  "form": "style-module-scss-module__YaL-lG__form",
  "segment": "style-module-scss-module__YaL-lG__segment",
  "select": "style-module-scss-module__YaL-lG__select",
  "select__categories": "style-module-scss-module__YaL-lG__select__categories",
  "wrapper": "style-module-scss-module__YaL-lG__wrapper",
});
